module.exports = __webpack_public_path__ + "static/005-77276794bd438e608d63f016bb1cb5c4.jpg";